import {getFeatureFlagsConfig} from '../api/getFeatureFlagsConfig';
import {FeatureFlags} from '../types/FeatureFlag';

export const getFeatureFlags = async (): Promise<FeatureFlags> => {
  const featureFlagList = await getFeatureFlagsConfig();
  return featureFlagList.reduce((prev, current) => ({...prev, [current.name]: current.enabled}), {});
};
